import { FC, useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useRouter } from 'next/router';
import KcbSmsVerificationRs from '@domain/rs/verification/KcbSmsVerificationRs';
import KcbIpinVerificationRs from '@domain/rs/verification/KcbIpinVerificationRs';
import { SOCIAL_ACCOUNT_TYPE } from '@domain/constant/v1/socicalType';

interface SocialHiddenInfoProps {
  verificationResponse: KcbSmsVerificationRs | KcbIpinVerificationRs | null;
}

const SocialHiddenInfo: FC<SocialHiddenInfoProps> = ({ verificationResponse }) => {
  const { setValue } = useFormContext();
  const { query } = useRouter();
  const { field: openIdField } = useController({ name: 'openId' });
  const { field: openIdProviderField } = useController({ name: 'openIdProvider' });
  const isIpinVerification = verificationResponse?.identificationType === 'IPIN';
  const isSmsVerification = verificationResponse?.identificationType === 'SMS';

  // 소셜 로그인 인풋 필드 자동 할당
  useEffect(() => {
    if (!query.openIdProvider) return;

    const { openId, openIdProvider, name, birthDate, mobile, email, genderFlag } = query;

    openIdField.onChange(openId?.toString() || null);
    openIdProviderField.onChange((openIdProvider?.toString() as SOCIAL_ACCOUNT_TYPE) || null);

    setValue('name', name);
    setValue('birthDate', birthDate);
    setValue('mobile', mobile);
    setValue('email', email);
    setValue('genderFlag', genderFlag);
  }, [query.openIdProvider]);

  useEffect(() => {
    if (!verificationResponse) return;
    const { mobile } = query;
    const { name, birthDate } = verificationResponse;

    setValue('name', name);
    setValue('birthDate', birthDate.slice(2));
    if (query.openIdProvider && isIpinVerification) setValue('mobile', mobile);
    if (isSmsVerification) setValue('mobile', (verificationResponse as KcbSmsVerificationRs)?.mobile);
  }, [verificationResponse, query.openIdProvider]);

  return null;
};

export default SocialHiddenInfo;
